import { defineStore } from 'pinia';
import { sortBy, filter, isEmpty } from 'lodash';
import { PRINT_STYLES_PIXEL } from '../../utils/constants';
import { bestMatchingComparedColor } from '@/utils/color-comparison';
import { CREATOR_API } from '@/api/creator-api';

export const useColorStore = defineStore('colors', {
  state: () => ({
    colors: {}
  }),

  getters: {
    color: state => colorId => {
      if (colorId >= 2 ** 24) {
        const hex = `#${(colorId - 2 ** 24).toString(16).padStart(6, '0')}`;
        return {
          id: colorId,
          hex,
          capabilities: PRINT_STYLES_PIXEL
        };
      }

      return state.colors[colorId] || null;
    },

    colorListByPrintStyle: state => printStyle => {
      return sortBy(
        filter(state.colors, color => color.capabilities.includes(printStyle)),
        ['position']
      );
    }
  },
  actions: {
    async loadFontColors() {
      if (isEmpty(this.colors)) {
        const { data } = await CREATOR_API.colors.get();

        this.colors = data;
      }
    },
    findColorForPrintStyle(colorId, printStyle) {
      const color = this.color(colorId);

      return bestMatchingComparedColor(
        color.hex,
        this.colorListByPrintStyle(printStyle).filter(
          color => color.comparable !== false
        )
      );
    }
  }
});
